import { EventEmitter, inject, Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { CLIENT_PLATFORM } from "@tokens/client-platform.token";
import { ClientPlatformEnum } from "@models/core/client-type";

@Injectable({
  providedIn: "root",
})
export class AppService {
  private readonly openPopover$ = new EventEmitter<boolean>();
  private readonly platform$ = inject(CLIENT_PLATFORM);

  private subscription: Subscription;

  constructor() {
    const userDeviceArray = [
      { device: "Windows", platform: /Windows NT/ },
      { device: "Macintosh", platform: /Macintosh/ },
    ];

    const platform = navigator.userAgent;

    function getPlatform(): ClientPlatformEnum {
      for (const i in userDeviceArray) {
        if (userDeviceArray[i].platform.test(platform)) {
          return userDeviceArray[i].device as ClientPlatformEnum;
        }
      }

      return null;
    }

    this.platform$.next(getPlatform());
  }

  subscribeOpenPopover(): Observable<boolean> {
    return this.openPopover$.asObservable();
  }

  toggleOpen(bool: boolean): void {
    this.openPopover$.emit(bool);
  }

  unsubscribes(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
